<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Teklif ver</h2>
       <div class="right-menu list-inline no-margin-bottom">

       </div>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
        <div class="row">
            <div class="col-12">

<div class="invoice-box">
  <table cellpadding="0" cellspacing="0">
    <tr class="information">
      <td colspan="4">
        <table>
          <tr>
            <td>
              {{posts.cari_kod}}<br>
              {{posts.cari_ad}}
            </td>

            <td>
            <select v-model="pb" style="border: none; background:#333; color:white; padding:10px">
                  <option value="TL">Türk Lirası</option>
                  <option value="$">Dolar</option>
				  <option value="€">Euro</option>	
                  <option value="£">Pound</option>
                </select>
            </td>
            <td><button @click="teklifkayit" class="btn btn-danger w-100">Kaydet</button></td>
          </tr>
        </table>
      </td>
    </tr>

    <tr class="heading">
      <td style="width: 65%; text-align:left" @click="addRow">Malzeme</td>
      <td style="width: 20%">Birim Fiyat</td>
      <td style="width: 5%">Miktar</td>
      <td style="width: 10%">Fiyat</td>
    </tr>

    <tr class="item" v-for="item in items" :key="item.price">
      <td><input disabled v-model="item.description" /></td>
      <td>{{pb}} <input type="text" v-model="item.price" /></td>
      <td><input type="text" v-model="item.quantity" /></td>
      <td>{{pb}} {{ item.price * item.quantity | currency }}</td>
    </tr>
  </table>
  <hr style="border:1px solid #484848">
  <table class="mt-3"  width="100%" border="0" align="center" cellpadding="2" cellspacing="2">
 	<tbody>
 	<tr>
 	<td width="56%" rowspan="3" align="left" valign="middle">
         <textarea v-model="bilgi" rows="5"  style="font-size: 16px; width: 100%; background:#333; color:#eee">
             Extra Açıklama alanı
         </textarea>
    </td>
 	<td width="7%" rowspan="3">&nbsp;</td>
 	<td style="height:40px" width="14%" align="left" valign="middle">Ara Toplam</td>
 	<td style="background:#333" width="23%" align="right" valign="middle">{{pb}} {{ total | currency}}</td>
 	</tr>
 	<tr>
 	<td align="right" valign="middle">İskonto ( % )</td>
 	<td align="right" valign="middle">
        <input style="text-align: right; border: none;" v-model.number="tax">
    </td>
 	</tr>
 	<tr>
 	<td align="right" valign="middle">Toplam</td>
 	<td style="background:#333" align="right" valign="middle">{{pb}} {{ totald | currency}}</td>
 	</tr>
 	</tbody>
 	</table>
</div>

            </div>
        </div>
      </div>  
    </section>
    <div v-if="progres.inprogres">
      <div id="spinner-front" class="show"> <img src="/set/ajax-loader.gif"/><br>{{progres.mesaj}} ...</div>
      <div id="spinner-back" class="show"></div>
    </div>     
  </div>
</template>

<script>
export default {
   created() {
     this.yetki();
  },
  data () {
    return {
      said:'',
      bid:'',
      sid : this.$route.params.id/8589,
      posts : {},
      cari:{},
      kullanici:[],
      malzeme:[],
      error :[],
      donem : this.$request.donem(), //kullanılmıyor
      log:[],
      ayar:this.$request.ayar(),
      items: [],
      tax: 0,
      pb:"TL",
      bilgi:'',
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      },
      required:0
    }
  },
  computed: {
    total() {
      return this.items.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
    totald() {
      return this.tax
        ? this.total - (this.total * (this.tax / 100))
        : this.total
    }    
  },
    methods : {
        yetki: function(){
            if (this.$helper.sayfayetki(592766)){
                let table = null
                if (this.ayar.ya=='sid'){
                    table = 'servis'
                    this.getPostsAsync(this.sid,table)
                }
                else{
                    table = 'kayit'
                    this.getPostsAsync(this.sid,table)
                }
            }
            else {
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
            }
        },
        teklifkayit(){
              this.$swal({
              title: 'Teklif Oluşturulacak',
              text: 'Malzeme kullanımı silinecek...',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then((result) => {
              if(result.value) {
                this.progres.inprogres = true
                let teklif = {
                no:this.sid,
                carid:this.posts.carid,
                fid:this.ayar.firmaid,
                tarih: new Date(),
                pb:this.pb,
                iskonto:this.tax,
                bilgi:this.bilgi
                }
                this.$request.post("teklif/",teklif)
                .then(res => {
                  if (res.data>0 && res.data != null)
                    {
                      this.satirekle(res.data)
                    }
                })
              }
            })
        },
        satirekle(id){
                  for (let i = 0; i < this.items.length; i++) {
                        let satir = {
                          tid:id,
                          stid:this.items[i].id,
                          adet:this.items[i].quantity,
                          fiyat:this.items[i].price,
                         }
                          this.$request.post("teklifsatir/",satir)
                          .then(res => {
                              if (res.data <= 0 && res.data == null){
                                  this.required = this.required +1
                              }
                          })
                     }
                     if (this.required == 0) {
                       this.$request.get("stok_hareketsil/"+this.sid)
                       .then(res => {
                         if ( res.error == false ){
                           this.$swal({
                            title: 'Teklif Oluşturuldu',
                            text: 'Servis Onaylanabilir...',
                            type: 'warning',
                            //showCancelButton: true,
                            confirmButtonText: 'Tamam',
                            showCloseButton: true,
                            showLoaderOnConfirm: true
                          }).then((result) => {
                            if(result.value) {

                      let log ={
                        servis_id : this.sid,
                        tarih: new Date(),
                        saat :new Date(Date.now()),
                        sd:0,
                        kid:this.ayar.kid,
                        islem: 'Teklif Oluşturuldu...'
                      }
                       this.$request.post("servis_log/",log)
                        .then(this.$router.go(-1))
                            }
                           })
                        }
                       })
                     }
        },
        getPostsAsync (sid,table){
          this.$request.get("detay/servis/"+this.ayar.ya+"/"+this.ayar.kid+'/'+sid+'/'+table)
          .then( res => {this.posts=res.servis
                this.$request.get("stok_hareketmikro/"+this.sid)
                .then(res => {
                   // this.malzeme = res.results
                    this.progres.inprogres = true
                    for (let i = 0; i < res.results.length; i++) {
                        let stok = {
                          id:res.results[i].stid,
                          description:res.results[i].isim,
                          quantity:res.results[i].adet,
                          price:0
                         }
                          this.items.push(stok)
                          this.progres.inprogres = false
                     }
                })
              })
          .catch(err => {this.error.push(err)})
        },
        // servis onaylama
        onChange(sid) {
            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'Servisi Onaylıyorum...',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then((result) => {
              if(result.value) {
                let islem = {
                  id:sid,
                  sd : 4,
                  onay:1
                }
                  this.$request.post("onay/",islem)
                  .then(res => {
                      let log ={
                        servis_id : res.data.id,
                        tarih: new Date(),
                        saat :new Date(Date.now()),
                        sd:res.data.sd,
                        kid:this.ayar.kid,
                        islem: 'Servis Onaylandı...'
                      }
                      this.$request.post("servis_log/",log)
                        .then(res => {
                            this.$swal('Onaylandı', 'İşlem Başarı ile tamamlandı', 'success')
                        })
                        .catch(this.$swal('Cancelled', 'Log Kaydı Yapılamadı', 'danger'))
                  })
                  .catch(this.$swal('Cancelled', 'Hata ile karşılaşıldı', 'danger'))
              }
            })
        },
        addRow() {
        this.items.push({ description: "", quantity: 1, price: 0 });
        },
     },
filters: {
    currency(value) {
      return value.toFixed(2);
    }     
   }
}
</script>
<style scoped>
    input{
        height: 40px;
        background: #333;
        color:#eee;
        border: none;
        font-weight: 400;
        font-size:16px
    };
    .invoice-box {
  max-width: 90%;
  margin: auto;
  padding: 10px;
  /*border: 1px solid #eee;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);*/
  font-size: 15px;
  line-height: 34px;
  font-family: 'Poppins', sans-serif !important;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(n + 2) {
  text-align: right;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  background:none;
  border-bottom: 3px solid #333;
  font-weight: normal;
 text-align:center
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  /*border-bottom: 1px solid #333;*/
  padding:5px;
  width: 100;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.item input {
  padding-left: 5px;
}

.invoice-box table tr.item td:first-child input {
  margin-left: -5px;
  width: 100%;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

.invoice-box input[type="number"] {
  width: 60px;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

        textarea{border: none; width: 100%; font-size: 16px;font-family: 'Poppins', sans-serif !important;; color: #555; font-weight: 400}
    </style>



// WEBPACK FOOTER //
// src/views/func/teklif.vue